import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { DashboardT } from 'business/definitions';

export const LAST_VIEWED_DASHBOARDS_QUERY_KEY = 'last_viewed_dashboards';

export const useGetLastViewedDashboards = () =>
    useQuery({
        queryKey: [LAST_VIEWED_DASHBOARDS_QUERY_KEY],

        queryFn: async () => {
            const response = await RQAPICallWithData<DashboardT[]>({
                endpoint: `explore/viewed_dashboards`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
